// ═══════════════════════════════════════════════════════════════════════
// Shared crash multiplier HEAT — the single source of the hero's colour ramp
// so the social-focus readout can match it exactly (v19). The hero recolours
// white → amber(≥2x) → orange(≥5x) → red(≥10x) while climbing, red on crash,
// and amber for the final betting-countdown seconds. Both surfaces read these
// two pure helpers so they can never drift.
// ═══════════════════════════════════════════════════════════════════════

export type CrashHeat = 'cool' | 'warm' | 'hot' | 'inferno'

/** The hero climb ramp: attribute flips at 2x / 5x / 10x only. */
export const crashHeatFor = (mult: number): CrashHeat =>
  mult >= 10 ? 'inferno' : mult >= 5 ? 'hot' : mult >= 2 ? 'warm' : 'cool'

/** The betting countdown warms to armed amber in the final seconds (≤3s), matching the hero. */
export const COUNTDOWN_ARMED_SECONDS = 3

// The data-heat value for the social-focus state-value span, per phase — kept
// in lockstep with the hero's colours: live → the climb ramp; crashed → red
// (via 'inferno'); betting with ≤3s left → amber ('warm'); otherwise white.
export type SocialStateHeat = CrashHeat | 'crashed'

export function resolveSocialStateHeat(input: {
  phase: 'betting' | 'live' | 'crashed' | 'settled'
  multiplier: number | null | undefined
  countdownSeconds?: number | null
}): SocialStateHeat {
  switch (input.phase) {
    case 'live':
      return crashHeatFor(input.multiplier ?? 1)
    case 'crashed':
      return 'crashed'
    case 'betting':
      return typeof input.countdownSeconds === 'number' &&
        input.countdownSeconds >= 0 &&
        input.countdownSeconds <= COUNTDOWN_ARMED_SECONDS
        ? 'warm'
        : 'cool'
    default:
      return 'cool'
  }
}
